import dayjs from 'dayjs';

export function dayjsFromTime(readableTime) {
  /**
   * Turns 9:00 am into an array consisting of
   *
   * [
   *    9,  // hour
   *    00, // minutes
   *    am  // am/pm
   * ]
   */
  let time = readableTime
    .split(/(:| )/)
    .filter(s => s != ":" && s != " ");

  /**
   * Convert hours to 24 hour format vs 12 hours.
   */
  let hour = time[2] == "am" ? time[0] : Number(time[0]) + 12;

  /**
   * Create our dayjs object with the hour and the minutes set.
   */
  let obj = dayjs(new Date())
    .set("hour", hour)
    .set("minute", time[1]);

  return obj
}



// WEBPACK FOOTER //
// ./scripts/lib/dayjs-helpers.js